
export default {
  show: "modal fade in",
  hide: "modal fade",
  backgroundShow: "modal-backdrop fade in",
  backgroundHide: "modal-backdrop fade",
  closeButton: "close",
  dialog: "modal-dialog",
  content: "modal-content",
  header: "modal-header",
  title: "modal-title",
  body: "modal-body",
  footer: "modal-footer",
  scrollDialog: "modal-dialog"
};



// WEBPACK FOOTER //
// src/common/modal-window.style.js